// extracted by mini-css-extract-plugin
export default {"table":"SoldOut_table__7dul3","search":"SoldOut_search__xbyjN","icons":"SoldOut_icons__gr+nI"};